import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib/theme';
import { BottomSheet, BottomSheetProps } from '@shared/ui/molecules';
import ModalContent from './ModalContent';
type WhereToFindSteamLoginModalMobileProps = BottomSheetProps;
const WhereToFindSteamLoginModalMobile: FC<WhereToFindSteamLoginModalMobileProps> = ({
  open,
  onClose,
  ...rest
}) => <BottomSheet open={open} onClose={onClose} {...rest}>
    <ContentWrapper>
      <ModalContent onClose={onClose} />
    </ContentWrapper>
  </BottomSheet>;
export default WhereToFindSteamLoginModalMobile;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.primary;
const ContentWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c1aoc2xs",
  propsAsIs: false,
  vars: {
    "c1aoc2xs-0": [_exp()]
  }
}));

require("./WhereToFindSteamLoginModalMobile.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./WhereToFindSteamLoginModalMobile.tsx");